// Translation dictionaries for the public-facing surfaces of the app.
// Only the screens a cold visitor hits are fully translated. Owner-only
// pages (Dashboard, Settings, Moderation) stay Russian for now — they
// were called out as a future-iteration target.

export const translations = {
  ru: {
    "common.retry": "Повторить",
    "common.loading": "Загрузка...",
    "common.cancel": "Отмена",

    "header.catalog": "Бары и магазины",
    "header.catalogShort": "Бары",
    "header.beers": "Сорта",
    "header.breweries": "Пивоварни",
    "header.dashboard": "Кабинет",
    "header.login": "Войти",
    "header.register": "Регистрация",
    "header.logout": "Выйти",
    "header.settings": "Настройки",
    "header.language": "Язык",
    "header.theme.light": "Светлая",
    "header.theme.dark": "Тёмная",
    "header.brandTagline": "Бары и магазины разливного пива",
    "header.screenMode": "Экранный режим",
    "header.profile": "Профиль",
    "header.account": "Аккаунт",
    "header.myPlace": "Моя страница",
    "header.moderation": "Модерация",
    "header.forOwners": "Для заведений",
    "header.menu.open": "Меню",
    "header.menu.close": "Закрыть меню",
    "header.menu.catalog": "Каталог",
    "header.menu.place": "Заведение",
    "header.menu.account": "Аккаунт",

    "catalog.documentTitle": "BrewSpot — каталог разливного пива",
    "catalog.searchPlaceholder": "Поиск по названию или адресу",
    "catalog.searchAria": "Поиск",
    "catalog.countFound": "Найдено заведений",
    "catalog.loadError": "Не удалось загрузить список заведений",
    "catalog.noActiveTaps": "Нет позиций",
    "catalog.top": "Топ",
    "catalog.viewMode": "Вид каталога",
    "catalog.viewList": "Списком",

    "catalog.sort.label": "Сортировка:",
    "catalog.sort.popular": "Больше позиций",
    "catalog.sort.alpha": "По алфавиту",
    "catalog.sort.city": "По городу",

    "catalog.hero.badge": "Обновляется в реальном времени",
    "catalog.hero.title": "BrewSpot — каталог заведений с разливным пивом",
    "catalog.hero.subtitle": "Разливное пиво в заведениях твоего города.",
    "catalog.hero.ctaFind": "Найти заведение",
    "catalog.hero.ctaOwner": "Я владелец заведения",
    "catalog.ownerBanner.title": "Вашего бара нет в списке?",
    "catalog.ownerBanner.body":
      "Добавьте заведение бесплатно: меню кранов онлайн, QR-меню на столы и экран для TV в зале. Подключение — около 15 минут.",
    "catalog.ownerBanner.cta": "Как подключиться",
    "catalog.hero.statPrefix": "Сейчас на кранах",
    "catalog.hero.statJoin": "в",
    "catalog.hero.boardTitle": "Недавно добавили",

    "catalog.empty.searchedTitle": "Ничего не нашлось",
    "catalog.empty.emptyTitle": "Каталог пока пуст",
    "catalog.empty.searchedBody":
      "Попробуй изменить запрос или очистить поиск — возможно, в другом городе есть подходящее заведение.",
    "catalog.empty.emptyBody": "Заведения скоро появятся. Есть свой бар? Будь первым.",
    "catalog.empty.reset": "Сбросить поиск",

    "catalog.favorites.title": "Избранное",
    "catalog.favorites.empty": "Пока ничего. Нажмите сердечко на карточке, чтобы сохранить.",
    "catalog.favorites.add": "Добавить в избранное",
    "catalog.favorites.remove": "Убрать из избранного",
    "catalog.allPlaces": "Все заведения",
    "catalog.map.title": "Заведения на карте",
    "catalog.map.button": "На карте",
    "catalog.map.close": "Закрыть карту",
    "catalog.map.noPlaces": "Нет заведений с координатами.",
    "catalog.map.route": "Маршрут",
    "catalog.map.menu": "Подробнее",
    "catalog.map.error": "Не удалось загрузить карту. Попробуйте позже.",
    "catalog.map.findMe": "Найти меня",
    "catalog.map.findMeDenied":
      "Доступ к геолокации отклонён. Разрешите его в настройках браузера.",
    "catalog.map.findMeUnsupported": "Геолокация недоступна в этом браузере.",

    "address.loading": "Поиск адресов...",
    "address.error": "Не удалось получить подсказки",

    "header.city.label": "Выбрать город",
    "header.city.search": "Найти город",
    "header.city.empty": "Все города",
    "header.city.noMatches": "Ничего не найдено",

    "catalog.geo.noPlacesInCountry": "В вашем городе ещё нет заведений. Выберите другой.",
    "catalog.geo.choose": "Выбрать город",

    "catalog.footer.tagline": "BrewSpot — каталог заведений с разливным пивом",
    "catalog.footer.disclaimer": "Пей ответственно. 18+",

    "footer.legal": "Правовая информация",
    "footer.forOwners": "Для заведений",
    "footer.faq": "FAQ",
    "footer.privacy": "Политика конфиденциальности",
    "footer.terms": "Пользовательское соглашение",
    "footer.cookies": "Политика Cookie",
    "footer.offer": "Публичная оферта",
    "footer.refund": "Политика возврата",

    "catalog.newBeers.title": "новинки в продаже",
    "catalog.newBeers.titleAll": "Новинки в каталоге",
    "catalog.newBeers.allLink": "Все сорта",

    "dashboard.title": "Кабинет",
    "dashboard.filters.all": "Все позиции",
    "dashboard.filters.active": "Активные",
    "dashboard.addTap": "Добавить позицию",
    "dashboard.share.button": "Поделиться меню",
    "dashboard.share.title": "Картинка для сторис",
    "dashboard.share.close": "Закрыть",
    "dashboard.share.previewAlt": "Превью картинки с меню кранов",
    "dashboard.share.share": "Поделиться",
    "dashboard.share.download": "Скачать картинку",
    "dashboard.share.error": "Не удалось подготовить картинку. Попробуйте ещё раз.",
    "dashboard.share.hintShare":
      "Выберите Instagram → «История» или Telegram. Если Instagram не предлагает историю, скачайте картинку и выберите её из галереи.",
    "dashboard.share.hintDownload":
      "Картинка 1080×1920 для сторис Instagram и Telegram. Создаётся на вашем устройстве и не сохраняется на сервере.",
    "dashboard.empty.title": "У вас пока нет позиций",
    "dashboard.empty.subtitle": "Добавьте первую!",
    "dashboard.empty.noActive": "Нет активных позиций",
    "dashboard.loadMore": "Показать ещё ({shown} из {total})",
    "dashboard.loadMore.loading": "Загрузка...",
    "dashboard.loading": "Загрузка...",
    "dashboard.delete.title": "Удалить позицию?",
    "dashboard.delete.confirm": "Удалить",
    "dashboard.delete.cancel": "Отмена",
    "dashboard.delete.body":
      "Вы уверены, что хотите удалить «{name}»? Это действие нельзя отменить.",
    "dashboard.actions.edit": "Редактировать",
    "dashboard.actions.delete": "Удалить",
    "dashboard.actions.toggle": "Переключить",
    "dashboard.col.tap": "Кран",
    "dashboard.col.beer": "Пиво",
    "dashboard.col.style": "Стиль",
    "dashboard.col.abv": "ABV",
    "dashboard.col.ibu": "IBU",
    "dashboard.col.price": "Цена",
    "dashboard.col.status": "Статус",
    "dashboard.col.actions": "Действия",
    "dashboard.col.name": "Название",
    "dashboard.col.brewery": "Пивоварня",
    "dashboard.aria.dragHandle": "Перетащить позицию {name}",
    "dashboard.aria.dragHint": "Перетащите для изменения порядка",
    "dashboard.aria.moveUp": "Переместить «{name}» выше",
    "dashboard.aria.moveDown": "Переместить «{name}» ниже",
    "dashboard.aria.toggleOff": "Отключить позицию {name}",
    "dashboard.aria.toggleOn": "Включить позицию {name}",
    "dashboard.aria.edit": "Редактировать позицию {name}",
    "dashboard.aria.delete": "Удалить позицию {name}",
    "dashboard.aria.editTapNumber": "Изменить номер крана для «{name}»",
    "dashboard.tapNumber.conflictTitle": "Конфликт номеров кранов",
    "dashboard.tapNumber.conflictBody":
      "Несколько активных кранов используют один номер. На экране показывается только тот, который активен дольше — исправьте номера, чтобы видеть все позиции.",
    "dashboard.tapNumber.conflictTooltip": "Этот номер занят другим активным краном",
    "dashboard.tapNumber.saveError": "Не удалось сохранить номер крана",
    "dashboard.status.active": "Активно",
    "dashboard.status.inactive": "Неактивно",

    "tapForm.titleNew": "Новая позиция",
    "tapForm.titleEdit": "Редактировать позицию",
    "tapForm.cancel": "Отмена",
    "tapForm.save": "Сохранить изменения",
    "tapForm.add": "Добавить позицию",
    "tapForm.saving": "Сохранение...",
    "tapForm.back": "Назад",
    "tapForm.fields.beerName": "Название пива",
    "tapForm.fields.brewery": "Пивоварня",
    "tapForm.fields.style": "Стиль",
    "tapForm.fields.styleNone": "Не указан",
    "tapForm.fields.abv": "ABV %",
    "tapForm.fields.ibu": "IBU",
    "tapForm.fields.og": "OG %",
    "tapForm.fields.price": "Цена ₽",
    "tapForm.fields.priceByVolume": "Цена по объёмам ₽",
    "tapForm.fields.volume": "Объём",
    "tapForm.fields.country": "Страна",
    "tapForm.fields.description": "Описание",
    "tapForm.fields.descriptionMax": "(макс. 2000 символов)",
    "tapForm.catalog.search": "Найти пиво в общем каталоге",
    "tapForm.catalog.unverified":
      "Это пиво ещё не проверено модератором — оно видно только в вашем меню и в ваших поисковых подсказках.",
    "tapForm.catalog.helper":
      "Или заполните поля ниже вручную — позиция попадёт в меню без привязки к каталогу.",
    "tapForm.catalog.lockedHelper":
      "Поля синхронизированы с каталогом. Цена и описание задаются для этого крана; чтобы переопределить остальные поля — нажмите «Изменить» рядом с нужным.",
    "tapForm.success.created": "Позиция добавлена",
    "tapForm.success.updated": "Изменения сохранены",

    "settings.brandTagline": "Магазины разливного пива",
    "settings.title": "Настройки",
    "settings.placesNav": "Бары и магазины",
    "settings.back": "Назад",
    "settings.tabs.account": "Аккаунт",
    "settings.tabs.presets": "Объёмы",
    "settings.tabs.branding": "Логотип и фото",
    "settings.tabs.location": "Расположение",
    "settings.tabs.contacts": "Контакты",
    "settings.tabs.schedule": "Время работы",
    "settings.tabs.screen": "Экранный режим",
    "settings.tabs.displays": "Экраны",
    "settings.tabs.qrcode": "QR-код",
    "settings.groups.venue": "Заведение",
    "settings.groups.screen": "Экран",
    "settings.groups.account": "Аккаунт",

    "settings.qrCode.title": "QR-код для гостей",
    "settings.qrCode.subtitle":
      "Распечатайте этот QR-код и разместите на столах или у входа. При сканировании гости попадут в публичное меню вашего заведения.",
    "settings.qrCode.linkLabel": "Ссылка на меню",
    "settings.qrCode.copy": "Скопировать",
    "settings.qrCode.copiedShort": "Скопировано",
    "settings.qrCode.copied": "Ссылка скопирована",
    "settings.qrCode.copyError": "Не удалось скопировать ссылку",
    "settings.qrCode.downloadPng": "Скачать PNG",
    "settings.qrCode.downloadSvg": "Скачать SVG",
    "settings.qrCode.stableNote":
      "Ссылка не меняется — QR-код можно напечатать один раз и пользоваться всегда.",
    "settings.qrCode.noSlug": "QR-код станет доступен после первой публикации заведения.",

    "settings.location.title": "Расположение заведения",
    "settings.location.subtitle":
      "Введите адрес и выберите подсказку или укажите точку на карте — заведение появится на карте каталога.",
    "settings.location.address": "Адрес",
    "settings.location.placeholder": "Москва, ул. Пивная, 1",
    "settings.location.cityLabel": "Город",
    "settings.location.cityEmpty": "не указан",
    "settings.location.coordsLabel": "Координаты",
    "settings.location.coordsEmpty":
      "Координаты не заданы — выберите подсказку из списка или кликните по карте.",
    "settings.location.mapHint": "Кликните по карте, чтобы поставить или передвинуть точку.",
    "settings.location.mapResolving": "Определяем адрес по координатам…",
    "settings.location.previewError": "Не удалось загрузить превью карты.",
    "settings.location.clear": "Очистить",
    "settings.location.noApiKey": "Ключ Яндекс Карт не настроен — подсказки и карта недоступны.",
    "settings.location.saved": "Расположение сохранено",
    "settings.location.saveError": "Не удалось сохранить расположение",
    "settings.save": "Сохранить",
    "settings.saving": "Сохранение...",
    "settings.sending": "Отправка...",
    "settings.account.title": "Настройки аккаунта",
    "settings.account.email": "Email",
    "settings.account.emailHelp": "Изменение потребует подтверждения на новый адрес",
    "settings.account.currentPassword": "Текущий пароль",
    "settings.account.currentPasswordPlaceholder": "Введите текущий пароль",
    "settings.account.newPassword": "Новый пароль",
    "settings.account.newPasswordPlaceholder": "Минимум 10 символов",
    "settings.account.confirmNewPassword": "Повторите новый пароль",
    "settings.account.confirmHelp": "Изменение потребует подтверждения на текущий email",
    "settings.account.confirmTitle": "Подтверждение отправлено по email",
    "settings.account.confirmEmail":
      "Для смены адреса перейдите по ссылке в письме, отправленном на новый адрес.",
    "settings.account.confirmPassword":
      "Для смены пароля перейдите по ссылке в письме, отправленном на текущий адрес.",
    "settings.presets.title": "Пресеты объёмов",
    "settings.presets.subtitle":
      "Задайте объёмы, для которых будет указываться цена при добавлении позиции (например: 0.5л, 1л, 1.5л).",
    "settings.presets.add": "Добавить",
    "settings.presets.placeholder": "0.5",
    "settings.presets.remove": "Удалить",
    "settings.presets.empty": "Пока нет пресетов",
    "settings.contacts.title": "Контакты",
    "settings.contacts.subtitle": "Эти контакты будут показаны на публичной странице заведения.",
    "settings.contacts.email": "Email для связи",
    "settings.contacts.telegram": "Telegram",
    "settings.contacts.instagram": "Instagram",
    "settings.contacts.phone": "Телефон",
    "settings.contacts.errors.fixBeforeSave": "Исправьте ошибки в полях перед сохранением",
    "settings.contacts.errors.phoneInvalid":
      "Телефон может содержать только цифры, пробелы и символы + - ( )",
    "settings.contacts.errors.phoneTooShort": "Введите телефон полностью (не меньше 5 цифр)",
    "settings.contacts.errors.emailInvalid": "Введите корректный email, например info@mybar.com",
    "settings.contacts.errors.telegramInvalid":
      "Имя в Telegram: латинские буквы, цифры и _ (5–32 символа)",
    "settings.contacts.errors.instagramInvalid":
      "Имя в Instagram: латинские буквы, цифры, _ и . (до 30 символов)",
    "settings.contacts.errors.vkInvalid":
      "Имя в ВКонтакте или ссылка вида https://vk.com/mybar (только латиница)",
    "settings.contacts.errors.websiteInvalid":
      "Введите корректный адрес сайта, например https://mybar.com",
    "settings.schedule.title": "Время работы",
    "settings.schedule.subtitle": "Часы работы по дням. Незаполненные дни считаются выходными.",
    "settings.schedule.closed": "Закрыто",
    "settings.schedule.from": "С",
    "settings.schedule.to": "До",

    "moderation.title": "Модерация каталога",
    "moderation.queueEmpty": "Очередь пуста. Все заявки обработаны.",
    "moderation.newBrewery": "новая пивоварня",
    "moderation.submittedBy": "Отправлено",
    "moderation.duplicates": "Похожие записи в каталоге:",
    "moderation.approve": "Одобрить",
    "moderation.reject": "Отклонить",
    "moderation.merge": "Слить с выбранным",
    "moderation.reasonPlaceholder": "Причина отказа (необязательно)",
    "moderation.catalog": "Каталог",
    "moderation.queue": "Очередь",
    "moderation.search": "Поиск",
    "moderation.searchPlaceholder": "Название или пивоварня",
    "moderation.empty": "Ничего не найдено.",
    "moderation.edit": "Редактировать",
    "moderation.cancel": "Отмена",
    "moderation.save": "Сохранить",
    "moderation.places.tab": "Заведения",
    "moderation.breweries.tab": "Пивоварни",
    "moderation.breweries.title": "Модерация пивоварен",
    "moderation.breweries.searchPlaceholder": "Название пивоварни",
    "moderation.breweries.empty": "Пивоварен пока нет.",
    "moderation.breweries.beerCount": "пива в каталоге",
    "moderation.breweries.viewPublic": "Открыть публичную страницу",
    "moderation.places.title": "Модерация заведений",
    "moderation.places.searchPlaceholder": "Название, slug, город или email владельца",
    "moderation.places.hiddenOnly": "Только скрытые",
    "moderation.places.owner": "Владелец",
    "moderation.places.activeTaps": "активных кранов",
    "moderation.places.hide": "Скрыть",
    "moderation.places.unhide": "Вернуть в каталог",
    "moderation.places.hideTitle": "Скрыть заведение из каталога",
    "moderation.places.hideAbout": "Заведение",
    "moderation.places.hideConfirm": "Скрыть",
    "moderation.places.reasonLabel": "Причина",
    "moderation.places.reasonPlaceholder": "Например: реклама других сервисов в названии",
    "moderation.places.reasonHelp":
      "Эту причину увидит владелец заведения в письме и на дашборде. Пишите её для не-технического читателя.",
    "moderation.places.reasonRequired": "Укажите причину",
    "moderation.places.hidden": "Заведение скрыто",
    "moderation.places.restored": "Заведение возвращено в каталог",
    "moderation.places.hideFailed": "Не удалось скрыть заведение",
    "moderation.places.unhideFailed": "Не удалось вернуть заведение",
    "moderation.places.hiddenBy": "Скрыл",
    "moderation.places.status.hidden": "скрыто модератором",
    "moderation.places.status.archived": "в архиве",
    "moderation.places.status.inactive": "скрыто по неактивности",
    "ownerBanner.hiddenByModeratorTitle": "Заведение скрыто модератором",
    "ownerBanner.hiddenByModeratorBody":
      "Гости не видят его в каталоге. Если решение кажется ошибочным — свяжитесь с поддержкой.",
    "ownerBanner.hiddenReason": "Причина",
    "ownerBanner.missingAddressTitle": "Ваше заведение не отображается в каталоге и на карте",
    "ownerBanner.missingAddressBody":
      "Добавьте адрес, чтобы гости могли найти заведение по поиску и увидеть его на карте.",
    "ownerBanner.missingAddressCta": "Перейти в настройки",

    "age.title": "Подтвердите возраст",
    "age.subtitle":
      "Этот сайт содержит информацию об алкогольной продукции. Вход разрешён только лицам старше 18 лет.",
    "age.question": "Вам уже исполнилось 18 лет?",
    "age.confirm": "Мне больше 18 лет",
    "age.deny": "Нет",
    "age.blockedTitle": "Доступ ограничен",
    "age.blockedMessage":
      "Сайт доступен только посетителям старше 18 лет. Возвращайтесь, когда подрастёте.",
    "age.disclaimer": "Чрезмерное употребление алкоголя вредит вашему здоровью. 18+",
  },

  en: {
    "common.retry": "Retry",
    "common.loading": "Loading...",
    "common.cancel": "Cancel",

    "header.catalog": "Bars & shops",
    "header.catalogShort": "Bars",
    "header.beers": "Beers",
    "header.breweries": "Breweries",
    "header.dashboard": "Dashboard",
    "header.login": "Sign in",
    "header.register": "Sign up",
    "header.logout": "Sign out",
    "header.settings": "Settings",
    "header.language": "Language",
    "header.theme.light": "Light",
    "header.theme.dark": "Dark",
    "header.brandTagline": "Craft beer bars and bottle shops",
    "header.screenMode": "Screen mode",
    "header.profile": "Profile",
    "header.account": "Account",
    "header.myPlace": "My page",
    "header.moderation": "Moderation",
    "header.forOwners": "For venues",
    "header.menu.open": "Menu",
    "header.menu.close": "Close menu",
    "header.menu.catalog": "Catalog",
    "header.menu.place": "Venue",
    "header.menu.account": "Account",

    "catalog.documentTitle": "BrewSpot — craft beer on tap, today",
    "catalog.searchPlaceholder": "Search by name, city or address",
    "catalog.searchAria": "Search",
    "catalog.countFound": "Places found",
    "catalog.loadError": "Couldn't load the places. Please try again.",
    "catalog.noActiveTaps": "No taps",
    "catalog.top": "Top",
    "catalog.viewMode": "Catalog view",
    "catalog.viewList": "List",

    "catalog.sort.label": "Sort:",
    "catalog.sort.popular": "Most taps",
    "catalog.sort.alpha": "A–Z",
    "catalog.sort.city": "By city",

    "catalog.hero.badge": "Always up to date",
    "catalog.hero.title": "BrewSpot — a catalogue of draft beer venues",
    "catalog.hero.subtitle": "Draft beer at venues across your city.",
    "catalog.hero.ctaFind": "Find a place",
    "catalog.hero.ctaOwner": "I own a bar — add it",
    "catalog.ownerBanner.title": "Your bar isn't listed?",
    "catalog.ownerBanner.body":
      "Add your venue for free: an online tap list, a QR menu for tables and a TV board for the room. Setup takes about 15 minutes.",
    "catalog.ownerBanner.cta": "How to join",
    "catalog.hero.statPrefix": "On tap right now:",
    "catalog.hero.statJoin": "across",
    "catalog.hero.boardTitle": "Just added",

    "catalog.empty.searchedTitle": "No matches",
    "catalog.empty.emptyTitle": "The catalogue is empty",
    "catalog.empty.searchedBody":
      "Try a different query or clear the filters — there might be something in a neighbouring city.",
    "catalog.empty.emptyBody": "Places will show up here soon. Own a bar? Be the first.",
    "catalog.empty.reset": "Clear search",

    "catalog.favorites.title": "Favorites",
    "catalog.favorites.empty": "Nothing here yet. Tap the heart on a card to save it.",
    "catalog.favorites.add": "Add to favorites",
    "catalog.favorites.remove": "Remove from favorites",
    "catalog.allPlaces": "All places",
    "catalog.map.title": "Places on the map",
    "catalog.map.button": "Map",
    "catalog.map.close": "Close map",
    "catalog.map.noPlaces": "No places with coordinates yet.",
    "catalog.map.route": "Route",
    "catalog.map.menu": "More info",
    "catalog.map.error": "Couldn't load the map. Please try again later.",
    "catalog.map.findMe": "Find me",
    "catalog.map.findMeDenied": "Location access was blocked. Allow it in your browser settings.",
    "catalog.map.findMeUnsupported": "Geolocation isn't available in this browser.",

    "address.loading": "Searching addresses...",
    "address.error": "Couldn't fetch suggestions",

    "header.city.label": "Choose city",
    "header.city.search": "Find a city",
    "header.city.empty": "All cities",
    "header.city.noMatches": "No matches",

    "catalog.geo.noPlacesInCountry": "No places in your city yet. Pick another one.",
    "catalog.geo.choose": "Choose city",

    "catalog.footer.tagline": "BrewSpot — live craft beer listings.",
    "catalog.footer.disclaimer": "Please drink responsibly. 21+",

    "footer.legal": "Legal",
    "footer.forOwners": "For venues",
    "footer.faq": "FAQ",
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.cookies": "Cookie Policy",
    "footer.offer": "Public Offer",
    "footer.refund": "Refund Policy",

    "catalog.newBeers.title": "new on tap",
    "catalog.newBeers.titleAll": "New in the catalog",
    "catalog.newBeers.allLink": "All beers",

    "dashboard.title": "Dashboard",
    "dashboard.filters.all": "All taps",
    "dashboard.filters.active": "Active",
    "dashboard.addTap": "Add tap",
    "dashboard.share.button": "Share menu",
    "dashboard.share.title": "Story image",
    "dashboard.share.close": "Close",
    "dashboard.share.previewAlt": "Preview of the tap list image",
    "dashboard.share.share": "Share",
    "dashboard.share.download": "Download image",
    "dashboard.share.error": "Couldn't prepare the image. Try again.",
    "dashboard.share.hintShare":
      "Pick Instagram → Story or Telegram. If Instagram doesn't offer Story, download the image and pick it from your gallery.",
    "dashboard.share.hintDownload":
      "A 1080×1920 image for Instagram and Telegram stories. It's generated on your device and never stored on the server.",
    "dashboard.empty.title": "No taps yet",
    "dashboard.empty.subtitle": "Add your first one!",
    "dashboard.empty.noActive": "No active taps",
    "dashboard.loadMore": "Load more ({shown} of {total})",
    "dashboard.loadMore.loading": "Loading...",
    "dashboard.loading": "Loading...",
    "dashboard.delete.title": "Delete this tap?",
    "dashboard.delete.confirm": "Delete",
    "dashboard.delete.cancel": "Cancel",
    "dashboard.delete.body": 'Are you sure you want to delete "{name}"? This can\'t be undone.',
    "dashboard.actions.edit": "Edit",
    "dashboard.actions.delete": "Delete",
    "dashboard.actions.toggle": "Toggle",
    "dashboard.col.tap": "Tap",
    "dashboard.col.beer": "Beer",
    "dashboard.col.style": "Style",
    "dashboard.col.abv": "ABV",
    "dashboard.col.ibu": "IBU",
    "dashboard.col.price": "Price",
    "dashboard.col.status": "Status",
    "dashboard.col.actions": "Actions",
    "dashboard.col.name": "Name",
    "dashboard.col.brewery": "Brewery",
    "dashboard.aria.dragHandle": "Drag tap {name}",
    "dashboard.aria.dragHint": "Drag to reorder",
    "dashboard.aria.moveUp": 'Move "{name}" up',
    "dashboard.aria.moveDown": 'Move "{name}" down',
    "dashboard.aria.toggleOff": "Disable tap {name}",
    "dashboard.aria.toggleOn": "Enable tap {name}",
    "dashboard.aria.edit": "Edit tap {name}",
    "dashboard.aria.delete": "Delete tap {name}",
    "dashboard.aria.editTapNumber": 'Edit tap number for "{name}"',
    "dashboard.tapNumber.conflictTitle": "Tap number conflict",
    "dashboard.tapNumber.conflictBody":
      "Multiple active taps share a number. Only the one that has been active longest is shown on the display — fix the numbers to see all taps.",
    "dashboard.tapNumber.conflictTooltip": "This number is already used by another active tap",
    "dashboard.tapNumber.saveError": "Failed to save tap number",
    "dashboard.status.active": "Active",
    "dashboard.status.inactive": "Inactive",

    "tapForm.titleNew": "New tap",
    "tapForm.titleEdit": "Edit tap",
    "tapForm.cancel": "Cancel",
    "tapForm.save": "Save changes",
    "tapForm.add": "Add tap",
    "tapForm.saving": "Saving...",
    "tapForm.back": "Back",
    "tapForm.fields.beerName": "Beer name",
    "tapForm.fields.brewery": "Brewery",
    "tapForm.fields.style": "Style",
    "tapForm.fields.styleNone": "Not set",
    "tapForm.fields.abv": "ABV %",
    "tapForm.fields.ibu": "IBU",
    "tapForm.fields.og": "OG %",
    "tapForm.fields.price": "Price ₽",
    "tapForm.fields.priceByVolume": "Price per volume ₽",
    "tapForm.fields.volume": "Volume",
    "tapForm.fields.country": "Country",
    "tapForm.fields.description": "Description",
    "tapForm.fields.descriptionMax": "(max 2000 chars)",
    "tapForm.catalog.search": "Search the shared catalogue",
    "tapForm.catalog.unverified":
      "This beer hasn't been moderator-approved yet — it shows up only in your menu and your own search suggestions.",
    "tapForm.catalog.helper":
      "Or fill the fields below manually — the tap will go on your menu without being linked to the catalogue.",
    "tapForm.catalog.lockedHelper":
      "Fields stay in sync with the catalogue. Price and description are per-tap; to override the rest, click “Edit” next to the field.",
    "tapForm.success.created": "Tap added",
    "tapForm.success.updated": "Changes saved",

    "settings.brandTagline": "Craft beer bottle shops",
    "settings.title": "Settings",
    "settings.placesNav": "Bars & shops",
    "settings.back": "Back",
    "settings.tabs.account": "Account",
    "settings.tabs.presets": "Volumes",
    "settings.tabs.branding": "Logo & photos",
    "settings.tabs.location": "Location",
    "settings.tabs.contacts": "Contacts",
    "settings.tabs.schedule": "Hours",
    "settings.tabs.screen": "Screen mode",
    "settings.tabs.displays": "Displays",
    "settings.tabs.qrcode": "QR code",
    "settings.groups.venue": "Venue",
    "settings.groups.screen": "Screen",
    "settings.groups.account": "Account",

    "settings.qrCode.title": "QR code for guests",
    "settings.qrCode.subtitle":
      "Print this QR code and place it on tables or at the entrance. Guests will be taken to your public menu.",
    "settings.qrCode.linkLabel": "Menu link",
    "settings.qrCode.copy": "Copy",
    "settings.qrCode.copiedShort": "Copied",
    "settings.qrCode.copied": "Link copied",
    "settings.qrCode.copyError": "Could not copy the link",
    "settings.qrCode.downloadPng": "Download PNG",
    "settings.qrCode.downloadSvg": "Download SVG",
    "settings.qrCode.stableNote":
      "The link never changes — print the QR code once and use it forever.",
    "settings.qrCode.noSlug": "The QR code will be available after the place is first published.",

    "settings.location.title": "Place location",
    "settings.location.subtitle":
      "Enter an address and pick a suggestion, or drop a pin on the map — the place will show up on the catalog map.",
    "settings.location.address": "Address",
    "settings.location.placeholder": "Moscow, Pivnaya St, 1",
    "settings.location.cityLabel": "City",
    "settings.location.cityEmpty": "not set",
    "settings.location.coordsLabel": "Coordinates",
    "settings.location.coordsEmpty":
      "No coordinates yet — pick a suggestion above or click the map.",
    "settings.location.mapHint": "Click the map to drop or move the pin.",
    "settings.location.mapResolving": "Resolving address from coordinates…",
    "settings.location.previewError": "Couldn't load the map preview.",
    "settings.location.clear": "Clear",
    "settings.location.noApiKey": "Yandex Maps API key is not configured.",
    "settings.location.saved": "Location saved",
    "settings.location.saveError": "Couldn't save location",
    "settings.save": "Save",
    "settings.saving": "Saving...",
    "settings.sending": "Sending...",
    "settings.account.title": "Account settings",
    "settings.account.email": "Email",
    "settings.account.emailHelp": "A change needs to be confirmed at the new address",
    "settings.account.currentPassword": "Current password",
    "settings.account.currentPasswordPlaceholder": "Enter your current password",
    "settings.account.newPassword": "New password",
    "settings.account.newPasswordPlaceholder": "At least 10 characters",
    "settings.account.confirmNewPassword": "Confirm new password",
    "settings.account.confirmHelp": "A change needs to be confirmed at the current email",
    "settings.account.confirmTitle": "Confirmation sent by email",
    "settings.account.confirmEmail":
      "To change the address, click the link in the email sent to the new address.",
    "settings.account.confirmPassword":
      "To change the password, click the link in the email sent to your current address.",
    "settings.presets.title": "Volume presets",
    "settings.presets.subtitle": "Set the volumes you'll price each tap by (e.g. 0.5L, 1L, 1.5L).",
    "settings.presets.add": "Add",
    "settings.presets.placeholder": "0.5",
    "settings.presets.remove": "Remove",
    "settings.presets.empty": "No presets yet",
    "settings.contacts.title": "Contacts",
    "settings.contacts.subtitle": "These contacts will be shown on the public place page.",
    "settings.contacts.email": "Contact email",
    "settings.contacts.telegram": "Telegram",
    "settings.contacts.instagram": "Instagram",
    "settings.contacts.phone": "Phone",
    "settings.contacts.errors.fixBeforeSave": "Fix the highlighted fields before saving",
    "settings.contacts.errors.phoneInvalid":
      "Phone may contain only digits, spaces and + - ( ) characters",
    "settings.contacts.errors.phoneTooShort": "Enter the full phone number (at least 5 digits)",
    "settings.contacts.errors.emailInvalid": "Enter a valid email, e.g. info@mybar.com",
    "settings.contacts.errors.telegramInvalid":
      "Telegram handle: latin letters, digits and _ (5–32 chars)",
    "settings.contacts.errors.instagramInvalid":
      "Instagram handle: latin letters, digits, _ and . (up to 30 chars)",
    "settings.contacts.errors.vkInvalid": "VK handle or URL like https://vk.com/mybar (latin only)",
    "settings.contacts.errors.websiteInvalid": "Enter a valid website URL, e.g. https://mybar.com",
    "settings.schedule.title": "Hours",
    "settings.schedule.subtitle": "Hours by day. Empty days count as closed.",
    "settings.schedule.closed": "Closed",
    "settings.schedule.from": "From",
    "settings.schedule.to": "To",

    "moderation.title": "Catalogue moderation",
    "moderation.queueEmpty": "Queue is empty. All entries processed.",
    "moderation.newBrewery": "new brewery",
    "moderation.submittedBy": "Submitted by",
    "moderation.duplicates": "Possible duplicates in the catalogue:",
    "moderation.approve": "Approve",
    "moderation.reject": "Reject",
    "moderation.merge": "Merge into selected",
    "moderation.reasonPlaceholder": "Reason (optional)",
    "moderation.catalog": "Catalogue",
    "moderation.queue": "Queue",
    "moderation.search": "Search",
    "moderation.searchPlaceholder": "Name or brewery",
    "moderation.empty": "Nothing found.",
    "moderation.edit": "Edit",
    "moderation.cancel": "Cancel",
    "moderation.save": "Save",
    "moderation.places.tab": "Places",
    "moderation.breweries.tab": "Breweries",
    "moderation.breweries.title": "Brewery moderation",
    "moderation.breweries.searchPlaceholder": "Brewery name",
    "moderation.breweries.empty": "No breweries yet.",
    "moderation.breweries.beerCount": "beers in catalog",
    "moderation.breweries.viewPublic": "Open public page",
    "moderation.places.title": "Place moderation",
    "moderation.places.searchPlaceholder": "Name, slug, city, or owner email",
    "moderation.places.hiddenOnly": "Hidden only",
    "moderation.places.owner": "Owner",
    "moderation.places.activeTaps": "active taps",
    "moderation.places.hide": "Hide",
    "moderation.places.unhide": "Restore",
    "moderation.places.hideTitle": "Hide place from catalogue",
    "moderation.places.hideAbout": "Place",
    "moderation.places.hideConfirm": "Hide",
    "moderation.places.reasonLabel": "Reason",
    "moderation.places.reasonPlaceholder": "E.g. promotional content in the name",
    "moderation.places.reasonHelp":
      "The owner will see this in their email and on the dashboard. Write for a non-technical reader.",
    "moderation.places.reasonRequired": "Reason is required",
    "moderation.places.hidden": "Place hidden",
    "moderation.places.restored": "Place restored",
    "moderation.places.hideFailed": "Could not hide the place",
    "moderation.places.unhideFailed": "Could not restore the place",
    "moderation.places.hiddenBy": "Hidden by",
    "moderation.places.status.hidden": "hidden by moderator",
    "moderation.places.status.archived": "archived",
    "moderation.places.status.inactive": "hidden for inactivity",
    "ownerBanner.hiddenByModeratorTitle": "Your place is hidden by a moderator",
    "ownerBanner.hiddenByModeratorBody":
      "It is not visible to guests in the catalogue. Contact support if you think the decision was a mistake.",
    "ownerBanner.hiddenReason": "Reason",
    "ownerBanner.missingAddressTitle": "Your place is not shown in the catalogue or on the map",
    "ownerBanner.missingAddressBody":
      "Add an address so guests can find your place in search and see it on the map.",
    "ownerBanner.missingAddressCta": "Open settings",

    "age.title": "Confirm your age",
    "age.subtitle":
      "This site contains information about alcoholic beverages. Entry is permitted only for visitors aged 18 and over.",
    "age.question": "Are you 18 or older?",
    "age.confirm": "I'm over 18",
    "age.deny": "No",
    "age.blockedTitle": "Access restricted",
    "age.blockedMessage":
      "This site is only available to visitors aged 18 and over. Please come back when you're older.",
    "age.disclaimer": "Excessive consumption of alcohol is harmful to your health.",
  },
};

export const SUPPORTED = ["ru", "en"];
export const DEFAULT_LOCALE = "ru";
